module.exports = __webpack_public_path__ + "img/faq2.a7e50f30.jpg";